<template>
  <form class="form form-user-agreements" @submit.prevent="postForm">

    <slide-x-left-transition :duration="600" :delay="600">
      <div class="form-group" v-show="show">
        <template v-for="(item,index) in user_agreements">
          <div class="input-wrapper">
            <!--v-model not working - value is passed as props 'checked'-->
            <ion-checkbox mode="md"
                          :checked="tempAgreements.length > 0 ? tempAgreements[index].isChecked : false"
                          @input="checked = target.value"
                          @ionChange="handleCheckbox($event, index, item.key, $event.target.value)">
            </ion-checkbox>
            <label class="checkbox-label">
              <i class="checkbox-caret" v-if="item.required">*</i>
              <div v-html="item.value"></div>
            </label>
          </div>
          <p class="error"
             v-if="errors['agreements.rodo.'+ item.key]"
             v-text="errors['agreements.rodo.'+ item.key][0]">
          </p>
        </template>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Akceptuję</span>
    </ion-button>

    <slide-x-left-transition :duration="400" :delay="700">
      <div v-if="show">
        <h6 class="text-up">Odmowa</h6>
        <hr>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" color="light" @click="goTo('UserLogout')">
      <span>Wyloguj mnie</span>
    </ion-button>

  </form>
</template>

<script>
  import goTo from '@/mixins/goto';
  import {mapState} from "vuex";
  import { cloneDeep } from 'lodash';

  export default {
    name: 'FormUserAgreements',
    mixins: [goTo],
    computed: {
      ...mapState({
        loading: state => state.profile.loading,
        errors: state => state.profile.errors,
        user_agreements: state => state.global.agreements.rodo,
      })
    },
    data() {
      return {
        show: false,
        form: {
          agreements: {
            rodo: {}  // dynamic (group name requested 5956#note-26)
          }
        },
        tempAgreements: [], // helper
      }
    },
    mounted(){
      this.show = true
      // refetch agreements if somehow not present
      // #7125
      if(this.user_agreements && this.user_agreements.length > 0){
        this.setAgreements()
      }else{
        setTimeout(() => {
          this.$store.dispatch('GLOBAL_AGREEMENTS_REQUEST').then(()=>{
            this.setAgreements()
          })
        }, 500);
      }
    },
    methods: {
      setAgreements(){
        // copy global agreements to local halper and unbind two-way
        this.tempAgreements = _.cloneDeep(this.user_agreements)
        // set all agreements to false (requested)
        this.tempAgreements.forEach((item) => {
          let obj = { [item.key]: false }
          Object.assign(this.form.agreements.rodo, obj)
        })
      },
      handleCheckbox(event, i, key, value) {
        const checkbox = event.target
        // prepare agreements
        let obj = {
          [key]: value == "on" ? true : false
        }
        // checkbox is set true
        if (checkbox.checked) {
          this.tempAgreements[i].isChecked = true
          Object.assign(this.form.agreements.rodo, obj)
        }
        // checkbox is set false
        else {
          this.tempAgreements[i].isChecked = false
          // Object.assign(this.form.agreements.rodo, obj)
          this.$set(this.form.agreements.rodo, key, false)
        }
      },
      postForm(e) {
        this.$store.dispatch('profile/PROFILE_AGREEMENTS_REQUEST', this.form)
            .then(() => {
              this.$store.commit('profile/PROFILE_SET_AGREEMENTS_REDIRECT', false);
              this.$store.commit('profile/PROFILE_SET_HEADER_DISABLED', false);
              // this.$store.dispatch('GLOBAL_TOAST','Otrzymaliśmy Twoje zgody.');
              //
              setTimeout(() => {
                this.$router.push({name: 'Dashboard'}).catch(err => {})
              }, 250);
            })
      }
    }
  }
</script>